import ArrayUtil from '../../utils/ArrayUtil';
import { defineMessages } from 'react-intl';

export const getRespondentStatuses = (surveys) => {
  const respondentStatuses = [];

  surveys.edges.forEach((edge) => {
    const { node } = edge;

    const { self, managers, peers, directReports, others } = node;

    if (self) {
      respondentStatuses.push(self.status);
    }

    if (ArrayUtil.isNotEmpty(managers)) {
      managers.forEach((asmt) => {
        if (asmt) {
          respondentStatuses.push(asmt.status);
        }
      });
    }

    if (ArrayUtil.isNotEmpty(others)) {
      others.forEach((asmt) => {
        if (asmt) {
          respondentStatuses.push(asmt.status);
        }
      });
    }

    if (ArrayUtil.isNotEmpty(peers)) {
      peers.forEach((asmt) => {
        if (asmt) {
          respondentStatuses.push(asmt.status);
        }
      });
    }

    if (ArrayUtil.isNotEmpty(directReports)) {
      directReports.forEach((asmt) => {
        if (asmt) {
          respondentStatuses.push(asmt.status);
        }
      });
    }
  });

  return respondentStatuses;
};

export const buildMessages = () => {
  return defineMessages({
    successNoti: {
      id: 'noti.success',
      defaultMessage: 'Success!',
    },
    sendInvite: {
      id: 'assessment.invite.send.plural',
      defaultMessage: 'Send Invites',
    },
    sendRemind: {
      id: 'assessment.remind.send.plural',
      defaultMessage: 'Send Reminders',
    },
  });
};
